import { render, staticRenderFns } from "./OddBg.vue?vue&type=template&id=d382138a&"
import script from "./OddBg.vue?vue&type=script&lang=js&"
export * from "./OddBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports